import React from "react";
import {Modal, Tabs, Tab} from "react-bootstrap";
import "./ProductModal.css";
function ProductModal(props) {
  console.log(props);
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      id="product__Modal"
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <span className="close__product-modal">X</span>
        <div className="product__detailes">
          <div className="product__detailes__left">
            <div className="product__image">{props.productImage}</div>
            <h4 className="product__sizes__title">Sizes Availible</h4>
            <p className="product__sizes">
              1 gallon
              <br />
              2.85 L<br />
              2 L<br />
              1 L<br />
              500 ml
              <br />
              360 ml
              <br />
              250 ml
            </p>
          </div>
          <div className="product__detailes__right">
            <h2>Fresh Milk Full Fat 1 Gallon</h2>
            <Tabs defaultActiveKey="details1" id="noanim-tab-example">
              <Tab eventKey="details1" title="Details 1">
                details 1
              </Tab>
              <Tab eventKey="details2" title="Details 2">
                details 2
              </Tab>
              <Tab eventKey="details3" title="Details 3">
                details 3
              </Tab>
            </Tabs>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ProductModal;
